import { NodeType, type ProductCategory } from '@amarantos/api-client'

export const nodeProductCategory: Record<NodeType, ProductCategory | null> = {
	[NodeType.manhole]: 'manhole',
	[NodeType.soakaway]: 'soakaway',
	[NodeType.pump_station]: 'pump_station',
	[NodeType.tank]: 'tank',
	[NodeType.separator]: 'separator',
	[NodeType.tie_in]: null,
	[NodeType.inlet]: null,
}
